enum PropertyDataType {
  GET_PROPERTIES_DATA_REQUEST = 'properties/getPropertiesDataRequest',
  GET_PROPERTIES_DATA_REJECTED = 'properties/getPropertiesDataRejected',
  GET_PROPERTIES_DATA_FULFILLED = 'properties/getPropertiesDataFulfilled',
}

export default PropertyDataType;
